// extracted by mini-css-extract-plugin
export default {"text-block":"gahnk","content":"A9dbV","title":"enGS3","skeleton":"oCG7t"};